/**
 * generic sizes enum
 */
// TODO: use this enum across all of the components
export const Sizes = {
  Xsmall: 'xsmall',
  Small: 'small',
  Medium: 'medium',
  Large: 'large',
  Xlarge: 'xlarge',
  Xxlarge: 'xxlarge',
} as const;

export type SizesType = typeof Sizes[keyof typeof Sizes];
